<div
  [ngClass]="popup.icon"
  (keyup)="onCancelByEscEey($event)"
  *ngIf="showPopup"
  [@opacity]
  class="popup-overlay"
  role="alert"
>
  <div class="l-spread popup-overlayClose" (click)="onCancel()"></div>

  <section class="l-layer-up popup-body">
    <header class="popup-top">
      <h2 *ngIf="title" class="popup-title">
        {{ title | translate }}
      </h2>
    </header>

    <main class="popup-main pad">
      <div class="t-row--med l-flex popup-main-row">
        <i
          *ngIf="popup.icon"
          class="popup-icon fas"
          [ngClass]="'fa-' + popup.icon"
        ></i>

        <div class="l-align-x l-flex-column l-cell-spread popup-subTitle">
          <p *ngFor="let subTitle of subTitles" class="w-full">
            {{ subTitle | translate }}
          </p>
        </div>
      </div>

      <form *ngIf="popup.form">
        <div *ngFor="let field of popup.form" class="t-row--small">
          <input
            [ngClass]="field.cssClass"
            class="t-input"
            type="{{ field.type ? field.type : 'text' }}"
            value="{{ field.value }}"
            [attr.aria-label]="field.label"
          />
        </div>
      </form>

      <code *ngIf="message" class="t-code">
        {{ message | translate }}
      </code>
    </main>

    <footer class="popup-bottom">
      <button class="t-button popup-btn-approve" (click)="onOk()">
        {{ okBtnText | translate }}
      </button>

      <button
        *ngIf="popup.approve"
        class="t-button popup-btn-cancel"
        (click)="onCancel()"
      >
        {{ cancelBtnText | translate }}
      </button>
    </footer>
  </section>
</div>
